import { Component, OnInit, OnDestroy, Inject, ViewChild, Input } from '@angular/core';
import { HistoryService } from '../../services/history.service';
import { tap } from 'rxjs/operators';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { ProfileFieldHistoryDataSource } from '../../datasources/profile-field-history.datasource';
import { Observable } from 'rxjs';

@Component({
  selector: 'field-data-historical-modal-modal',
  templateUrl: './field-data-historical-modal.component.html',
  styleUrls: ['./field-data-historical-modal.component.scss'],
})
export class FieldDataHistoricalModalComponent implements OnInit, OnDestroy {
  displayedColumns: Array<string> = ['happenedOn', 'name', 'from', 'to'];
  readonly dataSource: ProfileFieldHistoryDataSource;
  public rowCount: Observable<number>;
  personId: string;
  attribute: string;
  @Input()
  attributeName;
  @Input()
  id;

  readonly DEFAULT_PAGE_SIZE = 30;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private historyService: HistoryService) {
    this.dataSource = new ProfileFieldHistoryDataSource(historyService);
  }

  ngOnInit(): void {
    this.loadProfileHistory();
  }

  ngOnDestroy(): void {}

  ngAfterViewInit(): void {
    this.paginator.page.pipe(tap(() => this.loadProfileHistory())).subscribe();
  }

  loadProfileHistory(): void {
    this.dataSource.loadHistory(
      this.paginator.pageIndex,
      this.DEFAULT_PAGE_SIZE,
      this.id,
      this.attributeName
    );
  }
}
